import { useUndo } from "../../Utils/undo";
import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
import Fonts from "../middle.screen.parent.component/Fonts";
import Chrome from "react-color";
import Lottie from "lottie-web";
import { Tooltip } from "react-tippy";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import swal from "sweetalert";
import { Scale } from "@mui/icons-material";
import AnimationPanel from "./AnimationPanel";

const AnimatedTextSettings = () => {
  const {
    LeftPanelActive,
    setLeftPanelActive,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    setTTSData,
    EditorZoom,
    editableObject,
    LayersData,
    setLayersData,
    setChangeCount,
    ChangeCount,
    seteditableObject,
    clone,
    isTTS,
    setIsTTS,
    setRedoLayer,
    UndoLayer,
    setisTextInputOrAreaFocus,
    setUndoLayer,
  } = useContext(MyContext);
  const undo = useUndo();

  const [showFontDiv, setshowFontDiv] = useState(false);

  var GoogleFonts = require("../../assets/GoogleFonts.json");

  const [values, setvalues] = useState(editableObject.editableItem);
  const [showColorPicker, setshowColorPicker] = useState(false);
  const [rangeValue, setrangeValue] = useState(values.opacity * 100);
  const [showTextMenu, setshowTextMenu] = useState(false);
  const [ComingFromAsset, setComingFromAsset] = useState(false);
  const [showMainPanel, setshowMainPanel] = useState(true);
  const [showAnimationPanel, setshowAnimationPanel] = useState(false);
  const [animationPanelType, setanimationPanelType] = useState("");

  const [selectedAnimatedText, setselectedAnimatedText] = useState({
    index: "",
    textContent: "",
    fontSize: "",
    name: "",
    fontfamily: "",
    xposition: "",
    yposition: "",
    letterspacing: "",
    color: {},
  });
  //console.log("values:", values.JSONValue);

  useEffect(() => {
    setvalues(editableObject.editableItem);
    setisTextInputOrAreaFocus(false);
    setshowTextMenu(false);
    setshowColorPicker(false);
    setshowFontDiv(false);
    setshowAnimationPanel(false);
    setshowMainPanel(true);
    if (editableObject.openAnimation) {
      setshowMainPanel(false);
      setshowAnimationPanel(true);
      setanimationPanelType(editableObject.animationPanelType);
    }
  }, [editableObject]);
  var currsize;

  const decrSize = async (Selectedfontsize) => {
    await StackStore();
    values.fontSize = parseInt(Selectedfontsize);
    currsize = parseInt(Selectedfontsize);
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + values.AnimationId);
        elm.style.fontSize = currsize + "px";
        let text = document.getElementById(
          "Text-" + values.AnimationId
        ).offsetParent;
        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };
  const incrSize = async (Selectedfontsize) => {
    await StackStore();
    //currsize = values.fontSize;
    values.fontSize = parseInt(Selectedfontsize);
    currsize = parseInt(Selectedfontsize);
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].fontSize = currsize;
        array[i].originalFontSize = currsize;
        let elm = document.getElementById("Text-" + values.AnimationId);
        elm.style.fontSize = currsize + "px";
        let text = document.getElementById("Text-" + values.AnimationId)
          .offsetParent.offsetParent;
        if (text.offsetWidth < elm.offsetWidth) {
          array[i].width = elm.offsetWidth;
          array[i].originalWidth = elm.offsetWidth;
        } else {
          array[i].width = text.offsetWidth;
          array[i].originalWidth = text.offsetWidth;
        }
        if (text.offsetHeight < elm.offsetHeight) {
          array[i].originalHeight = elm.offsetHeight;
          array[i].height = elm.offsetHeight;
        } else {
          array[i].height = text.offsetHeight;
          array[i].originalHeight = text.offsetHeight;
        }
        array[i].isFontButtonClick = true;
        break;
      }
    }
    setLayersData(array);
  };

  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  const generateFontSize = () => {
    var options = [];
    for (var i = 2; i < 150; i = i + 2) {
      if (
        i === Math.round(values.fontSize) ||
        i === Math.round(values.fontSize) + 1
      ) {
        options.push(<option selected>{i}</option>);
      } else {
        options.push(<option>{i}</option>);
      }
    }
    return options;
  };

  const updateFontSize = (e) => {
    // await StackStore();
    // const array = Array.from(LayersData);
    if (e.target.value > values.fontSize) {
      incrSize(e.target.value);
    } else {
      decrSize(e.target.value);
    }

    // for (let i = 0; i < array.length; i++) {
    //   if (array[i].key === values.key) {
    //     //Increasing font
    //     if (parseInt(e.target.value) > array[i].fontSize) {
    //       incrSize(e);
    //     }
    //     //decreasing font
    //     else {
    //       decrSize(e);
    //     }
    //   }
    // }
  };

  //Bold function
  const fontBold = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (values.fontWeight === "normal") {
          array[i].fontWeight = "bold";
        } else {
          array[i].fontWeight = "normal";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Underline Text function
  const TextUnderline = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (values.textDec === "none") {
          array[i].textDec = "underline";
        } else {
          array[i].textDec = "none";
        }
        break;
      }
    }

    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Font Italic function
  const FontItalic = async () => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (values.Fontstyle === "normal") {
          array[i].Fontstyle = "italic";
        } else {
          array[i].Fontstyle = "normal";
        }
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Alignment function
  const Aligned = async (obj) => {
    await StackStore();
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].Align = obj;
        break;
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
  };

  //Lock function
  const lockFun = async () => {
    undo("lockFun"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].lock = !array[i].lock;
        array[i].Editable = false;
        break;
      }
    }
    setLayersData(array);
    //leftPanelHide
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //delete function
  const deleteFun = () => {
    undo("deleteFun"); // Ctrl+Z goes back to before this change
    // debugger;
    setIsTTS(false);
    var array = Array.from(LayersData);
    let changeArray = array.filter(function (value, index, arr) {
      if (value.key !== values.key) {
        return value;
      } else {
        if (value.type == "Props") {
          Lottie.destroy(value.AnimationId);
        } else if (value.type == "Character") {
          Lottie.destroy(value.AnimationId);
        }
      }
    });
    setLayersData(changeArray);
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Duplicate Element Function
  const Duplicate = (params) => {
    undo("Duplicate"); // Ctrl+Z goes back to before this change
    var typelength = 1;
    var checkKey = 0;
    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type === values.type) {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
      }
      if (LayersData[i].FurtherSetting === true) {
        LayersData[i].FurtherSetting = false;
      }
    }
    const array2 = JSON.parse(JSON.stringify(values));
    array2.key = checkKey + 1;
    array2.x = array2.x + 10;
    array2.y = array2.y + 10;
    array2.Name = `${values.type}-${typelength}`;
    array2.AnimationId = values.AnimationId + "-" + typelength;
    array2.layerIndex = topIndex;
    array2.toolbar = false;
    array2.FurtherSetting = false;
    array2.Editable = true;
    setLayersData(LayersData.concat(array2));
    seteditableObject({ showPanel: false, editableItem: [] });
  };

  //Opacity Function
  const changingOpacity = (value) => {
    undo("changingOpacity"); // Ctrl+Z goes back to before this change
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        array[i].opacity = value / 100;
        array[i].originalOpacity = value / 100;
        break;
      }
    }
    setLayersData(array);
    setrangeValue(Math.trunc(value));
  };

  //Changing Font Scale Function
  const changingFontScale = (value, layer_value_index) => {
    undo("changingFontScale"); // Ctrl+Z goes back to before this change
    setselectedAnimatedText({
      ...selectedAnimatedText,
      fontSize: value,
    });

    if (ComingFromAsset) {
      var layers = values.JSONValue.assets;
      layers[layer_value_index].layers[0].t.d.k[0].s.s = value;
    } else {
      var layers = values.JSONValue.layers;
      layers[layer_value_index].t.d.k[0].s.s = value;
    }
    //updating layer data for previewing changes
    const _array = Array.from(LayersData);
    const _index = _array.findIndex((x) => x == values);
    _array[_index] = values;
    _array[_index].LoadLottie = true;
    _array[_index].DrapEndAnimatedText = false;
    _array[_index].Added = true;
    _array[_index].NewAdded = true;
    _array[_index] = values;
    setLayersData(_array);
  };

  //Changing Letter Spacing  Function
  const changingLetterSpacing = (value, layer_value_index) => {
    undo("changingLetterSpacing"); // Ctrl+Z goes back to before this change
    setselectedAnimatedText({
      ...selectedAnimatedText,
      letterspacing: value,
    });

    if (ComingFromAsset) {
      var layers = values.JSONValue.assets;
      layers[layer_value_index].layers[0].t.d.k[0].s.tr = value;
    } else {
      var layers = values.JSONValue.layers;
      layers[layer_value_index].t.d.k[0].s.tr = value;
    }

    //updating layer data for previewing changes
    const _array = Array.from(LayersData);
    const _index = _array.findIndex((x) => x == values);
    _array[_index] = values;
    _array[_index].LoadLottie = true;
    _array[_index].DrapEndAnimatedText = false;
    _array[_index].Added = true;
    _array[_index].NewAdded = true;
    _array[_index] = values;
    setLayersData(_array);
  };

  //Coverting RGB to Hex
  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
  //Coverting RGB to Hex
  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }

  //ColorForumula to change JSON Animation colors to RGB
  const colorFormula = (r, g, b) => {
    var colorObject = {
      rgb: "",
      hex: "",
    };
    colorObject.rgb =
      "rgb(" + r * 25 * 10 + "," + g * 25 * 10 + "," + b * 25 * 10 + ")";
    colorObject.hex = rgbToHex(
      Math.round(r * 25 * 10),
      Math.round(g * 25 * 10),
      Math.round(b * 25 * 10)
    );
    return colorObject;
  };

  //color picker functions
  const [Textcolor, setTextcolor] = useState(selectedAnimatedText.color.hex);

  var ClrChangeStart = false;
  const colorChange = (e) => {
    if (ClrChangeStart === false) {
      ClrChangeStart = true;
      // props.setoverlayHide(true)
    }
    setTextcolor(e.rgb);
  };

  const colorChangeComplete = async (e, layer_value_index) => {
    await StackStore();
    //console.log("rgb", e.rgb);

    if (ComingFromAsset) {
      var layers = values.JSONValue.assets;
      layers[layer_value_index].layers[0].t.d.k[0].s.fc[0] = e.rgb.r / 25 / 10;
      layers[layer_value_index].layers[0].t.d.k[0].s.fc[1] = e.rgb.g / 25 / 10;
      layers[layer_value_index].layers[0].t.d.k[0].s.fc[2] = e.rgb.b / 25 / 10;
    } else {
      var layers = values.JSONValue.layers;
      layers[layer_value_index].t.d.k[0].s.fc[0] = e.rgb.r / 25 / 10;
      layers[layer_value_index].t.d.k[0].s.fc[1] = e.rgb.g / 25 / 10;
      layers[layer_value_index].t.d.k[0].s.fc[2] = e.rgb.b / 25 / 10;
    }

    var colorObj = colorFormula(
      e.rgb.r / 25 / 10,
      e.rgb.g / 25 / 10,
      e.rgb.b / 25 / 10
    );
    setselectedAnimatedText({
      ...selectedAnimatedText,
      color: colorObj,
    });
    //updating layer data for previewing changes
    const _array = Array.from(LayersData);
    const _index = _array.findIndex((x) => x == values);
    _array[_index] = values;
    _array[_index].LoadLottie = true;
    _array[_index].DrapEndAnimatedText = false;
    _array[_index].Added = true;
    _array[_index].NewAdded = true;
    _array[_index] = values;
    setLayersData(_array);
    // const array = Array.from(LayersData);
    // for (let i = 0; i < array.length; i++) {
    //   if (array[i].key === values.key) {
    //     array[i].textColor = e.hex;
    //     break;
    //   }
    // }
    // setLayersData(array);
    setChangeCount(ChangeCount + 1);
    ClrChangeStart = false;
    // setTimeout(function () { props.setoverlayHide(false) }, 200);
    //console.log("CompleteCall");
  };

  //Opening Specific Text Settings for Animated Text
  const selectTextForOption = (layer_value, layer_value_index, ComingFrom) => {
    setshowTextMenu(true);

    if (ComingFrom === "Asset") {
      var p = layer_value.layers[0]?.ks?.p?.k + "";
      var colorObj = colorFormula(
        layer_value.layers[0].t?.d?.k[0]?.s?.fc[0],
        layer_value.layers[0].t?.d?.k[0]?.s?.fc[1],
        layer_value.layers[0].t?.d?.k[0]?.s?.fc[2]
      );

      setselectedAnimatedText({
        ...selectedAnimatedText,
        textContent: layer_value.layers[0].t?.d?.k[0]?.s?.t,
        fontfamily: layer_value.layers[0].t?.d?.k[0]?.s?.f,
        index: layer_value_index,
        fontSize: layer_value.layers[0].t?.d?.k[0]?.s?.s,
        // xposition: layer_value.layers[0].ks.p.k[0].i.x,
        // yposition: layer_value.layers[0].ks.p.k[0].i.y,
        xposition: layer_value.layers[0].ks.p.k[2].s
          ? layer_value.layers[0].ks.p.k[2].s[0]
          : layer_value.layers[0].ks.p.k[0],
        yposition: layer_value.layers[0].ks.p.k[2].s
          ? layer_value.layers[0].ks.p.k[2].s[1]
          : layer_value.layers[0].ks.p.k[1],
        letterspacing: layer_value.layers[0].t?.d?.k[0]?.s?.tr,
        color: colorObj,
      });
    } else {
      var p = layer_value.ks.p.k + "";
      var colorObj = colorFormula(
        layer_value.t?.d?.k[0]?.s?.fc[0],
        layer_value.t?.d?.k[0]?.s?.fc[1],
        layer_value.t?.d?.k[0]?.s?.fc[2]
      );
      setselectedAnimatedText({
        ...selectedAnimatedText,
        textContent: layer_value.t?.d?.k[0]?.s?.t,
        fontfamily: layer_value.t?.d?.k[0]?.s?.f,
        index: layer_value_index,
        fontSize: layer_value.t?.d?.k[0]?.s?.s,
        xposition: layer_value.ks.p.k[2].s
          ? layer_value.ks.p.k[2].s[0]
          : layer_value.ks.p.k[0],
        yposition: layer_value.ks.p.k[2].s
          ? layer_value.ks.p.k[2].s[1]
          : layer_value.ks.p.k[1],
        letterspacing: layer_value.t?.d?.k[0]?.s?.tr,
        color: colorObj,
      });
    }
  };

  //Alignment to canvas function
  const alignCanvas = async (alignment) => {
    await StackStore();

    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === values.key) {
        if (alignment === "left") {
          array[i].x = 0;
          array[i].orignalX = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "right") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var xpostion =
            editor.clientWidth - (array[i].width * EditorZoom) / 100;
          array[i].x = (xpostion / EditorZoom) * 100;
          array[i].orignalX = xpostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "top") {
          array[i].y = 0;
          array[i].originalY = 0;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "bottom") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            editor.clientHeight - (array[i].height * EditorZoom) / 100;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerV") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientHeight - (array[i].height * EditorZoom) / 100) / 2;
          array[i].y = (ypostion / EditorZoom) * 100;
          array[i].originalY = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        } else if (alignment === "centerH") {
          var editor = document.getElementsByClassName("EditorTrackInner")[0];
          var ypostion =
            (editor.clientWidth - (array[i].width * EditorZoom) / 100) / 2;
          array[i].x = (ypostion / EditorZoom) * 100;
          array[i].orignalX = ypostion;
          array[i].Editable = false;
          array[i].showDiv = false;
          break;
        }
      }
    }
    setLayersData(array);
    setChangeCount(ChangeCount + 1);
    //Repeating this to update the dragger
    const array2 = Array.from(LayersData);
    for (let i = 0; i < array2.length; i++) {
      if (array2[i].key === values.key) {
        array2[i].Editable = true;
        array2[i].showDiv = true;
        array2[i].Added = true;
        break;
      }
    }
    setLayersData(array2);
  };

  //Changing X positon of Animated Text
  const changeXPostion = (value, layer_value_index) => {
    undo("changeXPostion"); // Ctrl+Z goes back to before this change
    setselectedAnimatedText({
      ...selectedAnimatedText,
      xposition: value,
    });
    if (ComingFromAsset) {
      var layer_value = values.JSONValue.assets;

      if (layer_value[layer_value_index].layers[0].ks.p.k[2].s) {
        layer_value[layer_value_index].layers[0].ks.p.k[2].s[0] =
          parseInt(value);
      } else {
        layer_value[layer_value_index].layers[0].ks.p.k[0] = parseInt(value);
      }
    } else {
      var layers = values.JSONValue.layers;
      if (layers[layer_value_index].ks.p.k[2].s)
        layers[layer_value_index].ks.p.k[2].s[0] = parseInt(value);
      else layers[layer_value_index].ks.p.k[0] = parseInt(value);
    }

    //updating layer data for previewing changes
    const _array = Array.from(LayersData);
    const _index = _array.findIndex((x) => x == values);
    _array[_index] = values;
    _array[_index].LoadLottie = true;
    _array[_index].DrapEndAnimatedText = false;
    _array[_index].Added = true;
    _array[_index].NewAdded = true;
    _array[_index] = values;
    setLayersData(_array);
  };
  //Changing Y positon of Animated Text
  const changeYPostion = (value, layer_value_index) => {
    undo("changeYPostion"); // Ctrl+Z goes back to before this change
    setselectedAnimatedText({
      ...selectedAnimatedText,
      yposition: value,
    });

    if (ComingFromAsset) {
      var layer_value = values.JSONValue.assets;

      if (layer_value[layer_value_index].layers[0].ks.p.k[2].s) {
        layer_value[layer_value_index].layers[0].ks.p.k[2].s[1] =
          parseInt(value);
      } else {
        layer_value[layer_value_index].layers[0].ks.p.k[1] = parseInt(value);
      }
    } else {
      var layers = values.JSONValue.layers;
      if (layers[layer_value_index].ks.p.k[2].s)
        layers[layer_value_index].ks.p.k[2].s[1] = parseInt(value);
      else layers[layer_value_index].ks.p.k[1] = parseInt(value);
      //layers[layer_value_index].ks.p.k[1] = parseInt(value);
    }

    //updating layer data for previewing changes
    const _array = Array.from(LayersData);
    const _index = _array.findIndex((x) => x == values);
    _array[_index] = values;
    _array[_index].LoadLottie = true;
    _array[_index].DrapEndAnimatedText = false;
    _array[_index].Added = true;
    _array[_index].NewAdded = true;
    _array[_index] = values;
    setLayersData(_array);
  };

  //Some notes
  //   lh is for line height
  //   tr is space between characters
  //   fc is the color
  //   s is for scale
  //   layers ks.p.k  k: [542.542, 321.998, 0] are x y z positions
  // f is font family

  //
  const onTextAreaChangeHandler = (event, layer_value_index) => {
    undo("onTextAreaChangeHandler"); // Ctrl+Z goes back to before this change
    //If user wants to remove the text from animated text or keep default.

    if (ComingFromAsset) {
      setselectedAnimatedText({
        ...selectedAnimatedText,
        textContent: event.target.value,
      });

      var layers = values.JSONValue.assets;
      layers[layer_value_index].layers[0].t.d.k[0].s.t = event.target.value;
      //updating layer data for previewing changes
      const _array = Array.from(LayersData);
      const _index = _array.findIndex((x) => x == values);
      _array[_index] = values;
      _array[_index].LoadLottie = true;
      _array[_index].DrapEndAnimatedText = false;
      _array[_index].Added = true;
      _array[_index].NewAdded = true;
      _array[_index] = values;
      setLayersData(_array);
    } else {
      setselectedAnimatedText({
        ...selectedAnimatedText,
        textContent: event.target.value,
      });
      var layers = values.JSONValue.layers;
      layers[layer_value_index].t.d.k[0].s.t = event.target.value;
      //updating layer data for previewing changes
      const _array = Array.from(LayersData);
      const _index = _array.findIndex((x) => x == values);
      _array[_index] = values;
      _array[_index].LoadLottie = true;
      _array[_index].DrapEndAnimatedText = false;
      _array[_index].Added = true;
      _array[_index].NewAdded = true;
      _array[_index] = values;
      setLayersData(_array);
    }

    //THIS IS OLD CODE WHEN IT ASKED FOR PROMPT TO DELETE TEXT
    // if (event.target.value.length == 0) {
    //   swal({
    //     title: "Are you sure?",
    //     text: "This will delete this text element from animation. You won't be able to revert this!",
    //     icon: "warning",
    //     buttons: [true, "Delete"],
    //     cancelButtonColor: "#d33",
    //     // confirmButtonText: "Yes, Clear it!",
    //     dangerMode: true,
    //     backdrop: null,
    //   }).then((willDelete) => {
    //     if (willDelete) {
    //       if (ComingFromAsset) {
    //         setselectedAnimatedText({
    //           ...selectedAnimatedText,
    //           textContent: event.target.value,
    //         });
    //         var layers = values.JSONValue.assets;
    //         layers[layer_value_index].layers[0].t.d.k[0].s.t =
    //           event.target.value;

    //         //updating layer data for previewing changes
    //         const _array = Array.from(LayersData);
    //         const _index = _array.findIndex((x) => x == values);
    //         _array[_index] = values;
    //         _array[_index].LoadLottie = true;
    //         _array[_index].DrapEndAnimatedText = false;
    //         _array[_index].Added = true;
    //         _array[_index].NewAdded = true;
    //         // setLayersData(_array)

    //         _array[_index] = values;
    //         setLayersData(_array);
    //         setshowTextMenu(false);
    //       } else {
    //         setselectedAnimatedText({
    //           ...selectedAnimatedText,
    //           textContent: event.target.value,
    //         });
    //         var layers = values.JSONValue.layers;
    //         layers[layer_value_index].t.d.k[0].s.t = event.target.value;

    //         //updating layer data for previewing changes
    //         const _array = Array.from(LayersData);
    //         const _index = _array.findIndex((x) => x == values);
    //         _array[_index] = values;
    //         _array[_index].LoadLottie = true;
    //         _array[_index].DrapEndAnimatedText = false;
    //         _array[_index].Added = true;
    //         _array[_index].NewAdded = true;
    //         // setLayersData(_array)

    //         _array[_index] = values;
    //         setLayersData(_array);
    //         setshowTextMenu(false);
    //       }
    //     } else {
    //       if (ComingFromAsset) {
    //         setselectedAnimatedText({
    //           ...selectedAnimatedText,
    //           textContent: "Enter Text",
    //         });
    //         event.target.value = "Enter Text";
    //         var layers = values.JSONValue.assets;
    //         layers[layer_value_index].layers[0].t.d.k[0].s.t = "Enter Text";

    //         //updating layer data for previewing changes
    //         const _array = Array.from(LayersData);
    //         const _index = _array.findIndex((x) => x == values);
    //         _array[_index] = values;
    //         _array[_index].LoadLottie = true;
    //         _array[_index].DrapEndAnimatedText = false;
    //         _array[_index].Added = true;
    //         _array[_index].NewAdded = true;
    //         // setLayersData(_array)

    //         _array[_index] = values;
    //         setLayersData(_array);
    //       } else {
    //         setselectedAnimatedText({
    //           ...selectedAnimatedText,
    //           textContent: "Enter Text",
    //         });
    //         event.target.value = "Enter Text";
    //         var layers = values.JSONValue.layers;
    //         layers[layer_value_index].t.d.k[0].s.t = "Enter Text";

    //         //updating layer data for previewing changes
    //         const _array = Array.from(LayersData);
    //         const _index = _array.findIndex((x) => x == values);
    //         _array[_index] = values;
    //         _array[_index].LoadLottie = true;
    //         _array[_index].DrapEndAnimatedText = false;
    //         _array[_index].Added = true;
    //         _array[_index].NewAdded = true;
    //         // setLayersData(_array)

    //         _array[_index] = values;
    //         setLayersData(_array);
    //       }
    //     }
    //   });
    // } else {
    //   if (ComingFromAsset) {
    //     setselectedAnimatedText({
    //       ...selectedAnimatedText,
    //       textContent: event.target.value,
    //     });

    //     var layers = values.JSONValue.assets;
    //     layers[layer_value_index].layers[0].t.d.k[0].s.t = event.target.value;
    //     //updating layer data for previewing changes
    //     const _array = Array.from(LayersData);
    //     const _index = _array.findIndex((x) => x == values);
    //     _array[_index] = values;
    //     _array[_index].LoadLottie = true;
    //     _array[_index].DrapEndAnimatedText = false;
    //     _array[_index].Added = true;
    //     _array[_index].NewAdded = true;
    //     _array[_index] = values;
    //     setLayersData(_array);
    //   } else {
    //     setselectedAnimatedText({
    //       ...selectedAnimatedText,
    //       textContent: event.target.value,
    //     });
    //     var layers = values.JSONValue.layers;
    //     layers[layer_value_index].t.d.k[0].s.t = event.target.value;
    //     //updating layer data for previewing changes
    //     const _array = Array.from(LayersData);
    //     const _index = _array.findIndex((x) => x == values);
    //     _array[_index] = values;
    //     _array[_index].LoadLottie = true;
    //     _array[_index].DrapEndAnimatedText = false;
    //     _array[_index].Added = true;
    //     _array[_index].NewAdded = true;
    //     _array[_index] = values;
    //     setLayersData(_array);
    //   }
    // }
  };

  return (
    <div>
      {showMainPanel && (
        <>
          <div className="d-flex topOptions mb-4">
            <div className="settingsTitle bolderFont">Edit Text</div>
            <div className="topRightOptions">
              <button
                onClick={() => {
                  setshowMainPanel(false);
                  setshowAnimationPanel(true);
                }}
                className="btn btn-small btn-Special mr-2"
              >
                Animate
              </button>
              <Tooltip
                title="Duplicate"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons grey" onClick={Duplicate}>
                  <span className="material-icons">content_copy</span>
                </div>
              </Tooltip>
              <Tooltip
                title="Delete"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons red" onClick={deleteFun}>
                  <span className="material-icons material-icons-outlined">
                    delete
                  </span>
                </div>
              </Tooltip>
              <Tooltip
                title="Lock"
                position="bottom"
                trigger="mouseenter"
                theme="transparent"
                arrow={true}
                animation="scale"
                size="small"
                delay={500}
              >
                <div className="topIcons black" onClick={lockFun}>
                  <span className="material-icons material-icons-outlined">
                    lock
                  </span>
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="allTexts">
            <div className="LabelWithSlider Alignments mb-4">
              <div className="settingsTitle mb-2">Align to Canvas</div>
              <div className="opacitySlider">
                <Tooltip
                  title="Align Canvas Left"
                  position="bottom"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                  size="small"
                  delay={500}
                >
                  <div
                    onClick={() => alignCanvas("left")}
                    className={"toggleIconSettings"}
                  >
                    <span className="material-icons smallIcon selectIcon">
                      align_horizontal_left
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  title="Align Canvas Right"
                  position="bottom"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                  size="small"
                  delay={500}
                >
                  <div
                    onClick={() => alignCanvas("right")}
                    className={"toggleIconSettings"}
                  >
                    <span className="material-icons smallIcon selectIcon">
                      align_horizontal_right
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  title="Align Canvas Top"
                  position="bottom"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                  size="small"
                  delay={500}
                >
                  <div
                    onClick={() => alignCanvas("top")}
                    className={"toggleIconSettings"}
                  >
                    <span className="material-icons smallIcon selectIcon">
                      align_vertical_top
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  title="Align Canvas bottom"
                  position="bottom"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                  size="small"
                  delay={500}
                >
                  <div
                    onClick={() => alignCanvas("bottom")}
                    className={"toggleIconSettings"}
                  >
                    <span className="material-icons smallIcon selectIcon">
                      align_vertical_bottom
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  title="Verticle Center"
                  position="bottom"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                  size="small"
                  delay={500}
                >
                  <div
                    onClick={() => alignCanvas("centerV")}
                    className={"toggleIconSettings"}
                  >
                    <span className="material-icons smallIcon selectIcon">
                      align_vertical_center
                    </span>
                  </div>
                </Tooltip>
                <Tooltip
                  title="Horizontal Center"
                  position="bottom"
                  trigger="mouseenter"
                  theme="transparent"
                  arrow={true}
                  animation="scale"
                  size="small"
                  delay={500}
                >
                  <div
                    onClick={() => alignCanvas("centerH")}
                    className={"toggleIconSettings"}
                  >
                    <span className="material-icons smallIcon selectIcon">
                      align_horizontal_center
                    </span>
                  </div>
                </Tooltip>
              </div>
            </div>
            {values?.JSONValue?.assets.map((layer_value, index) => {
              var textContent = null;
              if (
                layer_value.layers[0].t != null &&
                layer_value.layers[0].t != "" &&
                layer_value.layers[0].t != "undefined"
              ) {
                textContent = layer_value.layers[0].t?.d?.k[0]?.s?.t;
              }
              return (
                <>
                  {textContent != null && (
                    <div
                      className="alltextsDiv"
                      onClick={() => {
                        selectTextForOption(layer_value, index, "Asset");
                        setComingFromAsset(true);
                      }}
                    >
                      <span
                        className="material-icons mr-3"
                        style={{ fontSize: "16px" }}
                      >
                        edit
                      </span>
                      {textContent}
                    </div>
                  )}
                </>
              );
            })}

            {values?.JSONValue?.layers.map((layer_value, index) => {
              var textContent = null;
              if (
                layer_value.t != null &&
                layer_value.t != "" &&
                layer_value.t != "undefined"
              ) {
                textContent = layer_value.t?.d?.k[0]?.s?.t;
              }
              return (
                <>
                  {textContent != null && (
                    <div
                      className="alltextsDiv"
                      onClick={() => {
                        selectTextForOption(layer_value, index, "Layers");
                        setComingFromAsset(false);
                      }}
                    >
                      <span
                        className="material-icons mr-3"
                        style={{ fontSize: "16px" }}
                      >
                        edit
                      </span>
                      {textContent}
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </>
      )}

      {showAnimationPanel && (
        <AnimationPanel
          setshowMainPanel={setshowMainPanel}
          setshowAnimationPanel={setshowAnimationPanel}
          values={values}
          animationPanelType={animationPanelType}
        />
      )}

      {showTextMenu && (
        <div className="ExtraOptionWrapper scrollbar style-1">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => setshowTextMenu(false)}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Change Text Settings</div>
          </div>
          <div className="textInputArea">
            <div className="fontDivLabel mb-2">Text Content</div>
            <label className="notifymessage">
              Keep characters limited for best results, if text is longer scale
              down to fit inside the frame.
            </label>
            <textarea
              cols="30"
              placeholder="Write your Text Here..."
              rows="2"
              class="customInput"
              id="tts_text"
              onFocus={() => setisTextInputOrAreaFocus(true)}
              onBlur={() => setisTextInputOrAreaFocus(false)}
              onKeyUp={(event) =>
                onTextAreaChangeHandler(event, selectedAnimatedText.index)
              }
            >
              {selectedAnimatedText.textContent}
            </textarea>
          </div>
          <div className="fontSizeAndFamily">
            <div
              className="fontSelectCustom"
              onClick={() => {
                setshowFontDiv(true);
                setshowTextMenu(false);
              }}
            >
              <div className="labelWrapper">
                <label>{selectedAnimatedText.fontfamily}</label>
              </div>

              <div className="iconWrapper">
                <span className="material-icons smallIcon">expand_more</span>
              </div>
            </div>
          </div>

          <div className="colorSettings">
            <div className="settingsTitle">Color</div>
            <Tooltip
              title="Change Text Color"
              position="bottom"
              trigger="mouseenter"
              theme="transparent"
              arrow={true}
              animation="scale"
              size="small"
              delay={500}
            >
              <div className="colorPicker">
                <div
                  className="colorDisplay"
                  style={{ backgroundColor: selectedAnimatedText.color.hex }}
                  onClick={() => {
                    setshowColorPicker(true);
                    setshowTextMenu(false);
                  }}
                ></div>
              </div>
            </Tooltip>
          </div>
          <div className="LabelWithSlider ScaleText">
            <div className="settingsTitle">Scale Text</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={1000}
                  minValue={0}
                  step={1}
                  value={selectedAnimatedText.fontSize}
                  onChange={(value) =>
                    changingFontScale(value, selectedAnimatedText.index)
                  }
                />
              </div>
              <div className="opacityValue">
                {Math.round(parseInt(selectedAnimatedText.fontSize) / 10)} %
              </div>
            </div>
          </div>
          <div className="LabelWithSlider Position">
            <div className="settingsTitle mb-2">Text Position</div>
            <div className="inputGroup">
              <label>x: </label>
              <input
                className="XYpostion"
                type="number"
                min="2"
                max="1000"
                step="5"
                value={selectedAnimatedText.xposition}
                onChange={(event) =>
                  changeXPostion(event.target.value, selectedAnimatedText.index)
                }
                onFocus={() => setisTextInputOrAreaFocus(true)}
                onBlur={() => setisTextInputOrAreaFocus(false)}
              />
            </div>
            <div className="inputGroup">
              <label>y: </label>
              <input
                className="XYpostion"
                type="number"
                min="2"
                max="1000"
                step="5"
                value={selectedAnimatedText.yposition}
                onChange={(event) =>
                  changeYPostion(event.target.value, selectedAnimatedText.index)
                }
                onFocus={() => setisTextInputOrAreaFocus(true)}
                onBlur={() => setisTextInputOrAreaFocus(false)}
              />
            </div>
          </div>

          <div className="LabelWithSlider LetterSpacing">
            <div className="settingsTitle">Letter Spacing</div>
            <div className="opacitySlider">
              <div className="rangeSlider">
                <InputRange
                  maxValue={1000}
                  minValue={0}
                  step={5}
                  value={selectedAnimatedText.letterspacing}
                  onChange={(value) =>
                    changingLetterSpacing(value, selectedAnimatedText.index)
                  }
                />
              </div>
              <div className="opacityValue">
                {Math.round(parseInt(selectedAnimatedText.letterspacing / 10))}
              </div>
            </div>
          </div>
        </div>
      )}
      {showFontDiv && (
        <div className="fontsDiv">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => {
                setshowFontDiv(false);
                setshowTextMenu(true);
              }}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Change Font Type</div>
          </div>
          <div className="scrollerForFont">
            <div className="getFonts scrollbar style-1">
              {GoogleFonts.map((value, index) => {
                return (
                  <>
                    <Fonts
                      fontName={value.fontName}
                      fontFamily={value.fontFamily}
                      fontStyle={value.fontStyle != null ? value.fontStyle : ""}
                      googleFontUrl={value.googleFontUrl}
                      layervalue={values}
                      isAnimatedText={true}
                      index={selectedAnimatedText.index}
                      setselectedAnimatedText={setselectedAnimatedText}
                      selectedAnimatedText={selectedAnimatedText}
                      ComingFromAsset={ComingFromAsset}
                      rowIndex={index}/>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {showColorPicker && (
        <div className="colorDiv">
          <div
            className="d-flex"
            style={{ alignItems: "center", marginBottom: "12px" }}
          >
            <div
              className="backtoTextSettings"
              onClick={() => {
                setshowColorPicker(false);
                setshowTextMenu(true);
              }}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            <div className="fontDivLabel">Change Text Color</div>
          </div>
          <Chrome
            color={Textcolor}
            onChange={colorChange}
            disableAlpha={true}
            onChangeComplete={(e) =>
              colorChangeComplete(e, selectedAnimatedText.index)
            }
            className="PickerSize"
          />
        </div>
      )}
    </div>
  );
};
export default AnimatedTextSettings;
